@import './pk-donut-chart.variables';

:host {
  display: block;
  width: max-content;
}

:host(.legend--bottom) {
  width: 100%;
}

.donut-chart {
  display: inline-flex;
  line-height: initial;
  height: var(--donut-chart--height);
  width: max-content;
}

.donut-chart.legend--bottom {
  align-items: center;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
  width: 100%;
}

.donut-chart-legend--outline {
  display: flex;
  align-items: center;

  position: relative;
  margin-left: var(--donut-chart--legend-position-left);

  height: 100%;
  width: var(--donut-chart--legend-width);

  &.legend--bottom {
    margin-left: 0;
    height: fit-content;

    width: 100%;
  }
}

.apexcharts-canvas {
  height: initial !important;
  width: initial !important;
}

.donut-chart-legend {
  display: flex;
  flex-direction: row;
  flex: 1;

  &.legend--bottom {
    justify-content: space-between;
  }
}

.bullet,
.series,
.label {
  box-sizing: border-box;

  &:not(.legend--bottom) {
    height: 40px;

    padding-top: 8px;
    padding-bottom: 8px;

    &:not(.is-last) {
      border-bottom: 1px solid var(--pk-ui-02);
    }
  }
}

.bullet {
  display: flex;
  align-items: center;
  justify-content: center;

  padding-left: 8px;
  padding-right: 8px;

  span {
    color: var(--pk-chart-legend-bullet--color);
    border-style: solid;
    border-radius: 50%;
    border-width: var(--donut-chart--series-bullet-size);

    position: relative;
    margin-top: 4px;
  }
}

.series {
  color: var(--pk-text-01);

  font-family: var(--donut-chart--font-family-semibold);
  font-size: var(--donut-chart--series-font-size);

  padding-left: var(--pk-spacing-s);
}

.label {
  display: flex;
  align-items: center;

  span {
    display: inline-flex;
    color: var(--donut-chart--label-color);

    font-family: var(--donut-chart--font-family);
    font-size: var(--donut-chart--label-font-size);

    margin-top: 3px;
  }
}

.donut-chart-legend--series,
.donut-chart-legend--bullets,
.donut-chart-legend--labels {
  display: flex;
  flex-direction: column;
}

.donut-chart-legend--series {
  display: block;
  text-align: right;
}

.donut-chart-legend--labels {
  flex: 1;
}
